import "./../styles.scss";

import { LoadingOutlined } from "@ant-design/icons";
import { notification, Pagination, Select, Spin } from "antd";
import { Delete, EditIcon } from "components/icons";
import { Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { useOutletContext } from "react-router-dom";

import AccessControl from "../../../components/common/AccessControl/accessControl";
import CloseModal from "../../../components/icons/CloseModal";
import DeleteIcon from "../../../components/icons/DeleteIcon";
import VideoFilm from "../../../components/icons/VideoFilm";
import amplitude from "../../../externals/amplitude";
import { addZeeFolderValidation } from "../../../utils/validations";
import DeleteFolder from "./DeleteFolder";
import EditFolder from "./EditFolder";
const AddFolder = ({ ...props }) => {
  const { Option } = Select;
  const { settingsRecordsPerPage, tenantNames, id } = props;
  const { user, entityId } = useOutletContext();
  const [isOpen, setIsOpen] = useState(false);
  const [costumFields, setCostumFields] = useState({});
  const [folderNames, setFolderNames] = useState([]);
  const [folderDetails, setFolderDetails] = useState({});
  const [editmodalOpen, setEditModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [loader, setLoader] = useState(false);
  const [disable, setDisable] = useState(false);
  const [folderLoader, setFolderLoader] = useState(false);
  const [activePage, setActivePage] = useState(1);
  const [clientId, setClientId] = useState("");
  const userId = localStorage.getItem("__uid");
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(20);
  const [playerList, setPlayerList] = useState([]);
  const antIcon = <LoadingOutlined style={{ fontSize: 24, align: "center" }} spin />;
  const openModal = () => {
    setIsOpen(true);
    amplitude.logEvent("add_folder_clicked");
  };
  const closeModal = () => {
    setIsOpen(false);
    setClientId("");
    setInitialValues({ name: "" });
  };

  const [initialValues, setInitialValues] = useState({
    name: "",
  });
  const getCustomFields = async () => {
    setFolderLoader(true);
    const { getCustomFields } = props;
    const { value } = await getCustomFields({
      entityId: id,
    });
    if (value.success) {
      setCostumFields(value.setting);
      setFolderNames(value?.setting?.folder_name);
      setFolderLoader(false);
    }
  };
  const setClient = (e) => {
    setClientId(e);
  };
  useEffect(() => {
    getCustomFields();
  }, [entityId]);

  const handlePageChange = (current) => {
    setActivePage(current);
    setEnd(current * settingsRecordsPerPage);
    setStart(current * settingsRecordsPerPage - settingsRecordsPerPage);
  };

  const setFolderName = (e, setFieldValue) => {
    setFieldValue("name", e);
    setInitialValues({ ...initialValues, name: e });
  };

  const getFolder = async (payload) => {
    setLoader(true);
    const { getFolder } = props;
    const { value } = await getFolder(payload);
    if (value.status) {
      getCustomFields();
      setLoader(false);
      notification["success"]({ message: value.message });
    }
  };
  const handleSubmit = async () => {
    setLoader(true);
    if (folderNames?.filter((e) => e.name === initialValues?.name).length > 0) {
      notification["error"]({ message: "Package Name Already Exists" });
      setLoader(false);
      amplitude.logEvent("folder_already_exists", { folder: initialValues?.name });
    } else {
      const payload = {
        folder: {
          name: initialValues?.name,
        },
        settingId: costumFields?._id,
        clientId,
        entityId: id,
        action: "create",
      };
      getFolder(payload);
      closeModal();
      setLoader(false);
      amplitude.logEvent("folder_added", { folder: initialValues?.name });
    }
  };
  const editOpen = (data) => {
    setEditModalOpen(true);
    amplitude.logEvent("edit_folder_clicked", { folder: data?.name, folder_id: data?._id });
  };

  const delOpen = (data) => {
    setDeleteModalOpen(true);
    amplitude.logEvent("delete_folder_clicked", { folder: data?.name, folder_id: data?._id });
  };
  const actions = {
    delete_folder: true,
    edit_folder: true,
  };
  const handleSearch = (e) => {
    if (e) {
      setPlayerList(tenantNames.filter((d) => d?.name?.toLowerCase().includes(e.toLowerCase())));
    } else {
      setPlayerList(tenantNames);
    }
  };
  useEffect(() => {
    if (tenantNames) {
      setPlayerList(tenantNames);
    }
  }, [tenantNames]);
  const handleFolderTableAction = (profileFeature, menuItems) => {
    for (const key in actions) {
      if (profileFeature.hasOwnProperty(key) && profileFeature?.[key]) {
        switch (key) {
          case "delete_folder":
            menuItems.push({
              label: (
                <a
                  onClick={() => {
                    editOpen(folderDetails);
                  }}
                >
                  <VideoFilm />
                  <span>Edit</span>
                </a>
              ),
              key: "1",
            });
            break;
          case "edit_folder":
            menuItems.push({
              label: (
                <a
                  onClick={() => {
                    delOpen(folderDetails);
                  }}
                >
                  <DeleteIcon />
                  <span>Delete</span>
                </a>
              ),
              key: "2",
            });
            break;
        }
      }
    }
  };

  return (
    <>
      <EditFolder
        editmodalOpen={editmodalOpen}
        setEditModalOpen={setEditModalOpen}
        getFolder={getFolder}
        folderDetails={folderDetails}
        costumFields={costumFields}
        folderNames={folderNames}
        id={id}
      />
      <DeleteFolder
        deleteModalOpen={deleteModalOpen}
        setDeleteModalOpen={setDeleteModalOpen}
        folderDetails={folderDetails}
        getFolder={getFolder}
        costumFields={costumFields}
        id={id}
      />
      <Modal
        isOpen={isOpen}
        onRequestClose={closeModal}
        shouldCloseOnOverlayClick={false}
        contentLabel="Filter Modal"
        portalClassName="react-modal"
        overlayClassName="modal"
        className="modal-dialog react-modal-dialog-xs modal-dialog-centered"
      >
        <div className="modal-content">
          <AccessControl code="add_folder" page="organization-profile">
            <div className="react-modal-header">
              <h5 className="react-modal-title">Add Folder</h5>
              <button type="button" onClick={closeModal} className="btn btn__default">
                <CloseModal />
              </button>
            </div>
          </AccessControl>
          <Formik initialValues={initialValues} validationSchema={addZeeFolderValidation} onSubmit={handleSubmit}>
            {({ errors, touched, setFieldValue, values }) => (
              <Form>
                <div className="react-modal-body">
                  <div className="form-container">
                    <div className="form-group">
                      <label className="form-label">
                        Folder Name <span className="required">*</span>
                      </label>
                      <Field
                        className="form-control"
                        name="foldername"
                        onChange={(e) => setFolderName(e.target.value, setFieldValue)}
                      />
                      {touched.name && errors.name && <div className="invalid-feedback">{errors.name}</div>}
                    </div>
                    {user?.hasOwnProperty("clientId") && (
                      <>
                        <div className="field-items mb-4">
                          <label className="form-label"> Select Client</label>
                          <div className="form-pop-trigger-block">
                            <Select
                              showSearch
                              className="custom-ant-select"
                              name="clientId"
                              filterOption={false}
                              onChange={(e) => setClient(e)}
                              placeholder="Select Client"
                              onSearch={(e) => handleSearch(e)}
                              dropdownStyle={{ zIndex: 99999999 }}
                            >
                              {playerList.length > 0 &&
                                playerList.map((data, index) => {
                                  return (
                                    <>
                                      <Option key={index} value={data._id}>
                                        {data.name}
                                      </Option>
                                    </>
                                  );
                                })}
                            </Select>
                          </div>
                        </div>
                      </>
                    )}
                    <button className="btn btn-primary" type="submit" disabled={disable}>
                      Add
                      {loader === true ? <Spin indicator={antIcon} /> : ""}
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Modal>
      <div className="col-md-12">
        <div className="border-block groups-block">
          <div className="left-block">
            <h4 className="title-sm-t">Folders</h4>
          </div>
          <AccessControl code="add_folder" page="organization-profile">
            <div className="right-btn-block">
              <div class="button-container">
                <button class="btn btn-primary" onClick={openModal}>
                  Add Folder
                </button>
              </div>
            </div>
          </AccessControl>
        </div>
        <br />
        <div className="configuration-items-row mt-3 row">
          <div className="row mb-4 justify-content-start">
            <div className="col-md-6">
              <h5 className="title-small mb-0">Added Folders</h5>
            </div>
          </div>
          {folderNames?.slice(start, end)?.map((data) => {
            return (
              <>
                <div className="col-md-2">
                  <div className="confi-block-col-container configuration-column flex-column gap-0 p-2">
                    <div className="confi-block-col">
                      {/* <Dropdown
                      onClick={() => {
                        setFolderDetails(data);
                      }}
                      className=""
                      overlay={
                        <AccessControl
                          code="menuItem"
                          page="configuration"
                          handleTableAction={handleFolderTableAction}
                        />

                        // <Menu
                        //   items={[
                        //     {
                        //       label: (
                        //         <a
                        //           onClick={() => {
                        //             editOpen(data);
                        //           }}
                        //         >
                        //           <VideoFilm />
                        //           <span>Edit</span>
                        //         </a>
                        //       ),
                        //       key: "1",
                        //     },
                        //     includes(["admin", "superadmin"], user.role)
                        //       ? {
                        //           label: (
                        //             <a
                        //               onClick={() => {
                        //                 delOpen(data);
                        //               }}
                        //             >
                        //               <DeleteIcon />
                        //               <span>Delete</span>
                        //             </a>
                        //           ),
                        //           key: "2",
                        //         }
                        //       : null,
                        //   ]}
                        // />
                      }
                      trigger={["click"]}
                      overlayClassName={"tableActionBlock"}
                      placement={"bottomRight"}
                    >
                      <a className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
                        <TheeDotsIcon />
                      </a>
                    </Dropdown> */}
                      {/* <div className="icon-block">
                      <VideoGroup />
                    </div> */}
                      <h4 className="word-break-common">
                        {data?.name
                          .split(" ")
                          .map((letter, index) => letter.charAt(0).toUpperCase() + letter.slice(1).toLowerCase())
                          .join(" ")}
                      </h4>
                    </div>
                    {/* <div>{convertIsoDateToStandardFormat(data?.createdAt)}</div> */}
                    {/* <div className="btn-action">
                      <button
                        key="1"
                        className="btn btn-edit btn-primary"
                        onClick={() => {
                          editOpen(data);
                        }}
                      >
                        Edit
                      </button>
                    </div> */}
                    <div className="action-buttons gap-3">
                      <AccessControl code="edit_folder" page="organization-profile">
                        <button>
                          <EditIcon
                            onClick={() => {
                              setFolderDetails(data);
                              editOpen(data);
                            }}
                          />
                        </button>
                      </AccessControl>
                      <AccessControl code="delete_folder" page="organization-profile">
                        <button>
                          <Delete
                            onClick={() => {
                              setFolderDetails(data);
                              delOpen(data);
                            }}
                          />
                        </button>
                      </AccessControl>
                    </div>
                  </div>
                </div>
              </>
            );
          })}
        </div>
        <Pagination
          showSizeChanger={false}
          current={activePage}
          pageSize={settingsRecordsPerPage}
          onChange={handlePageChange}
          total={folderNames?.length}
          className="text-center mt-3"
        />
      </div>
    </>
  );
};
export default AddFolder;
